import { cn } from "@/lib/utils";

export function StatCard({ label, value, icon: Icon, tone = "primary", sub, testid }) {
  const tones = {
    primary: "text-blue-400 bg-blue-500/10 border-blue-500/20",
    emerald: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20",
    amber: "text-amber-400 bg-amber-500/10 border-amber-500/20",
    red: "text-red-400 bg-red-500/10 border-red-500/20",
    slate: "text-slate-300 bg-slate-500/10 border-slate-500/20",
    purple: "text-violet-400 bg-violet-500/10 border-violet-500/20",
  };
  return (
    <div
      data-testid={testid}
      className="rounded-xl border border-border bg-card/90 p-5 shadow-lg transition-all duration-200 hover:border-slate-600 hover:shadow-xl"
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{label}</p>
          <p className="mt-2 font-heading text-3xl font-extrabold tracking-tight text-foreground">{value}</p>
          {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
        </div>
        {Icon && (
          <div className={cn("flex h-11 w-11 items-center justify-center rounded-lg border", tones[tone])}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </div>
  );
}
